import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { citiesAPI } from '../services/api';
import SEOHead from '../components/SEOHead';

const Tours = () => {
  const { data: cities = [] } = useQuery({ queryKey: ['cities'], queryFn: () => citiesAPI.getAll().then((r) => r.data) });

  const TOUR_PROVIDERS = [
    { name: 'Viator', url: 'https://www.viator.com' },
    { name: 'GetYourGuide', url: 'https://www.getyourguide.com' },
    { name: 'Klook', url: 'https://www.klook.com' },
  ];

  return (
    <>
      <SEOHead
        title="Tours & Activities - World Cup 2026 - WorldCup Fan Planner"
        description="Discover tours and activities in FIFA World Cup 2026 host cities. Partner links to major experience booking sites."
      />
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Tours</h1>
      <p className="text-gray-600 dark:text-gray-400 mb-6">Discover tours and activities in host cities.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {TOUR_PROVIDERS.map((t) => (
          <a key={t.name} href={t.url} target="_blank" rel="noopener noreferrer" className="p-4 rounded-lg bg-white dark:bg-gray-800 shadow dark:shadow-gray-900 border dark:border-gray-700 hover:ring-2 hover:ring-amber-500">
            {t.name}
          </a>
        ))}
      </div>
      <h2 className="text-xl font-bold mb-4">City Guides</h2>
      <div className="flex flex-wrap gap-2">
        {cities.map((c) => (
          <Link key={c.id} to={`/cities/${c.slug || c.id}`} className="px-4 py-2 rounded-lg bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200 hover:bg-amber-200 dark:hover:bg-amber-900/60">
            {c.name}
          </Link>
        ))}
      </div>
    </div>
    </>
  );
};

export default Tours;
